import { useParams } from '@ksyos/router';
import { Absence } from './Absence';
import { EmploymentList } from './EmploymentList';
import { GeneralSettings } from './GeneralSettings';
import { KsyosAccount } from './KsyosAccount';
import { ProfileHeader } from './ProfileHeader';
import { ProfileRegistrationCodes } from './ProfileRegistrationCodes';

export function ProfileSettings() {
    const { id: practitionerId } = useParams() as { id: string };

    return (
        <>
            <ProfileHeader practitionerId={practitionerId} />
            <GeneralSettings practitionerId={practitionerId} />
            <ProfileRegistrationCodes practitionerId={practitionerId} />
            <KsyosAccount practitionerId={practitionerId} />
            <Absence practitionerId={practitionerId} />
            <EmploymentList practitionerId={practitionerId} />
        </>
    );
}
